import { createAsyncThunk } from "@reduxjs/toolkit";
import type { ComplianceValue } from "../../api/instances/complianceApi/types";
import { getAllStorageObjects } from "../../api/instances/storageApi/methods";

export const getComplianceObjectsAction = createAsyncThunk(
  "compliance/getComplianceObjects",
  async (_, { rejectWithValue }) => {
    try {
      return await getAllStorageObjects<ComplianceValue>(
        "ai_agents_compliance",
      );
    } catch (e: unknown) {
      rejectWithValue(e);
    }
  },
);
